import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Summary from "./components/Summary";

export default function App() {
  document.title = "Who is Rich Frank?";
  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <Navbar></Navbar>
      <About></About>
      <Projects></Projects>
      <Summary></Summary>
      <Skills></Skills>
      <Contact></Contact>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/App.js